export default __webpack_public_path__ + "static/media/Settings_Normal.1e22f751.svg";